import moment from 'moment';
import uniq from 'lodash/uniq';

export const getFirstLetter = (customer) => {
  const firstLetterOfFirstName = customer.firstName.substr(0, 1);
  return firstLetterOfFirstName.toUpperCase();
};

export const paymentCardExpired = (cardDetails) => {
  if (!cardDetails) {
    return false;
  }

  const { exp_month, exp_year } = cardDetails;
  const date = moment.utc(`${exp_month}/${exp_year}`, 'M/YYYY');

  return date.isBefore(moment.utc(), 'month');
}

export const getEnabledLetters = customers => uniq(customers.map(customer => getFirstLetter(customer)));
